import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1a8a2efc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "activation" }
const _hoisted_2 = {
  key: 0,
  class: "activation"
}
const _hoisted_3 = { style: {"font-size":"28px"} }
const _hoisted_4 = { style: {"font-size":"28px"} }
const _hoisted_5 = { style: {"color":"#027DB4"} }
const _hoisted_6 = { style: {"margin-top":"50px"} }
const _hoisted_7 = {
  key: 1,
  class: "activation"
}
const _hoisted_8 = {
  key: 0,
  class: "activation"
}
const _hoisted_9 = { style: {"font-size":"28px"} }
const _hoisted_10 = {
  key: 1,
  class: "activation"
}
const _hoisted_11 = { style: {"font-size":"28px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_space = _resolveComponent("a-space")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isflag)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.t('page.activation.txtone')) + "：" + _toDisplayString(_ctx.email), 1),
          _createElementVNode("p", _hoisted_4, [
            _createTextVNode(_toDisplayString(_ctx.t('page.activation.txtstart')) + " ", 1),
            _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.t('page.activation.txttime')), 1),
            _createTextVNode(" " + _toDisplayString(_ctx.t('page.activation.txtend')), 1)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_a_space, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_button, {
                  type: "primary",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleBack('login')))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t('page.activation.btnback')), 1)
                  ]),
                  _: 1
                }),
                (_ctx.isBtn)
                  ? (_openBlock(), _createBlock(_component_a_button, {
                      key: 0,
                      type: "primary",
                      onClick: _ctx.handleGoToEmail
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.t('page.activation.gotoemail')), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick"]))
                  : (_openBlock(), _createBlock(_component_a_button, {
                      key: 1,
                      onClick: _ctx.handleClose
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("关闭")
                      ]),
                      _: 1
                    }, 8, ["onClick"]))
              ]),
              _: 1
            })
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_7, [
          (_ctx.isShow)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.t('page.success.txtsucess')), 1),
                _createVNode(_component_a_button, {
                  type: "primary",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleBack('login')))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t('page.success.login')), 1)
                  ]),
                  _: 1
                })
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.t('page.activation.txterror')), 1),
                _createVNode(_component_a_button, {
                  type: "primary",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleBack('regist')))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t('page.success.regist')), 1)
                  ]),
                  _: 1
                })
              ]))
        ]))
  ]))
}